// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { TelemetryEventMap, dispatchTelemetryEvent, genericTelemetryClickDispatcher, getPageContentType } from "@msnews/social-utils";

export interface SocialBarPanelTelemetryObjects {
    likeButton: TelemetryObjectBase;
    activeReactionButton: TelemetryObjectBase;
    reactionsCount: TelemetryObjectBase;
    commentsButton: TelemetryObjectBase;
    reactionsParent: TelemetryObjectBase;
}

export const socialBarPanelTelemetryContracts = {
    reactionsParent: {
        name: "Reaction",
        content: {
            type: getPageContentType()
        }
    },
    likeButton: {
        name: "Like",
        behavior: TelemetryBehaviorType.Reactlike, // dynamically updated
        content: {
            type: getPageContentType(),
            headline: "Like" // dynamically updated
        }
    },
    reactionsCount: {
        name: "Reactions",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType(),
            headline: "Reactions"
        }
    },
    commentsButton: {
        name: "Comments",
        behavior: TelemetryBehaviorType.Show,
        content: {
            type: TelemetryContentType.Article,
            headline: "Comments"
        }
    }
};

export const socialBarPanelTelemetryActionDispatchers = {
    likeButtonClick: genericTelemetryClickDispatcher,
    commentsButtonClick: genericTelemetryClickDispatcher,
    likeButtonHover: (element: any, telemetryObject: any): void => {
        const behavior = TelemetryBehaviorType.Show;
        const telemetryEventDispatcherInfo = {
            ...TelemetryEventMap.genericHover,
            contract: {...(telemetryObject && telemetryObject.contract), behavior}
        };

        dispatchTelemetryEvent(telemetryEventDispatcherInfo, element);
    }
};